import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6d8tw85g3: FaireProductEntity = {
  token: "p_d6d8tw85g3",
  type: "product",
  name: "Kids White Cows Western T-Shirt",
  brandToken: "b_a42k6qezb7",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c7f70fe049d7e7d66f66c39abc5ffd14928fd7df6927ca52a3fc654e902bb1ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84278be5a167cc0ce14f21001733fcc1974017d860be223bf0f6c14e1a80284d.jpeg",
  ],
  priceDollars: 11,
  description:
    "\nKids White Cows Western T-Shirt ETA: 3-5 Days Step up your little one's style game with our Kids White Cows Western T-Shirt. Made from high-quality materials, this t-shirt offers both comfort and durability, perfect for all their adventures. Plus, with our quick ETA of 3-5 days, you won't have to wait long to see them rockin' this cute cow design. Get yours now and elevate your child's wardrobe today.\nMaterial is polyester",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:24.899Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
